<template>
  <transition name="fade">
    <GlobalAlert v-if="isVisibleButtonToTop" @click="scrollToTop" buttonSelectedColor="main" iconClass="fa-angles-up" :yMargin="20" horizontalPosition="right" title="Back to Top" />
  </transition>
</template>

<script>
import GlobalAlert from '@snippets/base/GlobalAlert.vue';
export default {
  components: { GlobalAlert },
  name: 'BackToTopButton',
  data() {
    return {
      isVisibleButtonToTop: false,
    };
  },
  created() {
    window.addEventListener('scroll', this.scrollFunction);
  },
  methods: {
    // Controla la visibilidad del botón al hacer scroll:
    scrollFunction() {
      if (window.scrollY > 300) {
        this.isVisibleButtonToTop = true;
      } else {
        this.isVisibleButtonToTop = false;
      }
    },
    // Realiza el scroll del botón:
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
  beforeDestroy() {
    // Limpieza del listener:
    window.removeEventListener('scroll', this.scrollFunction);
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
